// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"b3152a4c","703":"f03f2714"}[chunkId] + ".chunk.js";
};